var site = site || {};

(function ($) {
  $('html,body').addClass('quiz-loaded');

  // function to pop Loading Results modal
  //
  var pop_loading = function ($loading) {
    $('body').addClass('quiz-loading-results');
    var options = {
      content: $loading,
      className: 'colorbox--quiz--loading',
      width: '100%',
      height: '100%',
      fixed: true
    };

    options['overlayClose'] = false;
    options['closeButton'] = false;

    options['onComplete'] = function () {
      var _this = this;

      $('html,body').addClass('no-scroll');
      $('html,body').addClass('overlay-active');
      $('html,body').addClass('quiz-loaded');

      $.colorbox.resize();
    };

    options['onCleanup'] = function () {
      var _this = this;

      $('html,body').removeClass('no-scroll');
      $('html,body').removeClass('overlay-active');
    };

    generic.overlay.launch(options);
  };

  $(document).on('quiz-scroll-to', function (e, top) {
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });

  Drupal.behaviors.quizLandingPageFormatterV1 = {
    attach: function (context, settings) {
      var $formatters = $('.js-quiz-landing-page-formatter', context);
      var $form = $('.js-form-formatter', context);
      var $backLink = $('.js-form-formatter__back-btn.js-back-link', $form);
      var $newBackLink = $backLink.clone(true);
      var $formFormatterInner = $('.form-formatter__inner', $form);
      var $stepTrack = $formFormatterInner.find('.js-form-step-track');
      var $backLinkStep = $stepTrack.find('.js-back-link');

      // disable autoscroll in chrome
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      $(window).on('unload', function () {
        $(window).scrollTop(0);
      });

      if ($form.length > 0) {
        $newBackLink.find('.icon').remove();
        $backLink.remove();
        $formFormatterInner.append($newBackLink);
        $backLinkStep.html(site.translations.product.ff_step_text);
      }

      var that = this;

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $resultContainer = $('.js-quiz-landing-page-formatter__results', $formatter);
        var $loading = $('.js-quiz-landing-page-formatter__loading', $formatter);
        var $formContainer = $('.js-quiz-landing-page-quiz-form', $formatter);
        var form_name = $formatter.data('form-name');
        var quiz_info = window.__quiz_info__[form_name];
        var quiz_form = window.__quiz_form__[form_name];
        var use_page_js = $formatter.data('use-page-js');
        var init_state = $formatter.data('init-state');
        var $stickyFooter = $('.js-quiz-landing-page-footer-cta', $formatter);

        /*
         * This will set the height of quiz landing formatter since it is
         * fixed.
         */
        $formatter.on('mantle-form:set-height', function (e) {
          var quiz_top = $formatter.offset().top;
          var viewportHeight = $(window).height();
          var fixed_footer_cta = 0; // hardcoded for now
          var quizformatterHeight = viewportHeight - quiz_top - fixed_footer_cta;
          var displayQuizOnePage = $formatter.hasClass('entire-quiz-one-page');

          if (displayQuizOnePage) {
            $formatter.height('auto');
            $formatter.css('min-height', 'auto');
          } else {
            $formatter.height(quizformatterHeight);
            $formatter.css('min-height', quizformatterHeight);
          }
        });

        /*
         * Trigger height setting for use during mobile since we're not taking
         * over the entire page. We want to consume the available space below
         * the footer.
         */
        $(window).on(
          'resize scroll',
          _.debounce(function () {
            $formatter.trigger('mantle-form:set-height');
          }, 100)
        );
        $formatter.trigger('mantle-form:set-height');

        $formatter.on('mantle-form:scroll-to-top', function (e) {
          // On desktop we scroll the div into view
          if ($(window).width() > 768) {
            var quiz_top = $formatter.offset().top;
            var window_top = $(window).scrollTop();

            // scroll to top if quiz top isn't in view
            if (quiz_top < window_top) {
              window.scrollTo({
                top: quiz_top,
                behavior: 'smooth'
              });
            }

            return;
          }
          // mobile we scroll the fixed scroll container
          $('.js-quiz-landing-page-formatter__inner', $formatter).scrollTop(0);
        });

        $formatter.on('mantle-form:submit-requested', function (e) {
          pop_loading($loading);

          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');
          var form_answers = manager.gather_answers();
          // PG backed forms need to make a remote call.
          var save_promise = manager.save_answers(form_answers);
          var query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);

          query_string = 'show_results=1&' + query_string;
          $formatter.trigger('form-set-pushstate', [query_string]);

          save_promise.then(function () {
            $formatter.trigger('mantle-form:request-form-results', [form_answers, false]);
          });
        });

        $formatter.on('mantle-form:request-form-results', function (e, form_answers, show_loading) {
          if (!!show_loading) {
            pop_loading($loading);
          }
          var result_promise = MantleQuiz.rpc.get_quiz_results(form_name, form_answers);

          result_promise.then(function (result_html) {
            $formatter.trigger('mantle-quiz-render-results', [result_html]);
          });
        });

        $formatter.on('click', '.js-mantle-form-reset', function (e) {
          e.preventDefault();
          var $forms = $('.js-form-formatter', $formatter);
          var displayQuizOnePage = $formatter.hasClass('entire-quiz-one-page');
          $forms.trigger('form-reset');
          $formatter.removeClass('show-results');
          $formatter.addClass('show-quiz');
          $formatter.trigger('mantle-form:scroll-to-top');
          $formatter.find('.site-email-signup__field').val('');
          if (!!displayQuizOnePage) {
            $('body').removeClass('quiz-page-results-loaded');
          }
        });

        if (!init_state) {
          init_state = 'bare_form';
        }

        if (JSBoot.URL.getParam('init_state')) {
          init_state = JSBoot.URL.getParam('init_state');
        }

        // initialize the quiz form and quiz_info PGStates.
        MantleQuiz.quiz_info_state.getSubject(form_name, quiz_info);
        MantleQuiz.quiz_form_state.getSubject(form_name, quiz_form);

        $formatter.on('mantle-quiz-render-results', function (e, render_pack) {
          $resultContainer.html(render_pack.html);

          var loaded_func = function () {
            Drupal.attachBehaviors($resultContainer);
            window.setTimeout(function () {
              prodcat.data.getNewProducts($resultContainer);
              var productIds = prodcat.data.collectProductIds($resultContainer);
              var analyticsSettings = Drupal.settings.analytics
                ? Drupal.settings.analytics.analytics_tagging_enabled
                : false;

              $(document).trigger('FoundationFinderResults', [{ productIds: productIds }]);
              // we wait a bit to give time to load assets
              $formatter.trigger('mantle-quiz-reveal-results');
            }, 500);
          };

          MantleQuiz.render_pack_to(render_pack, {
            target: $resultContainer,
            loaded_func: loaded_func
          });
        });

        // Implements mantle-quiz-submit-requested
        $formatter.on('mantle-quiz-reveal-results', function (e) {
          var displayQuizOnePage = $formatter.hasClass('entire-quiz-one-page');
          var topPosition = 0;
          var $resultFormatter = $resultContainer.closest('.js-quiz-page-formatter-results');
          var $foundationResult = $formatter.find('.js-foundation-finder-result-foundation');
          var $productWrapper = $foundationResult.find('.js-product-brief-product-info-wrapper');
          var $tryminiResult = $formatter.find('.js-foundation-result-trymini');
          var $tryminiWrapper = $formatter.find('.js-trymini-warapper');
          var tryLink;
          var $tryMini;

          if ($tryminiResult.length > 0) {
            $tryminiWrapper.removeClass('hidden');
            $tryminiWrapper.appendTo($productWrapper);
            $tryminiResult.each(function () {
              tryLink = $(this).find('.js-spp-link').attr('href');
              $tryMini = $(this).closest('.js-quiz-result-section').find('.js-trymini-link');
              $tryMini.attr('href', tryLink);
            });
          }

          $('body').removeClass('quiz-loading-results');
          $.colorbox.close();
          $formatter.addClass('show-results');
          if (displayQuizOnePage) {
            $('body').addClass('quiz-page-results-loaded');
            topPosition = calcTopPosition($resultFormatter);
            $resultFormatter.trigger('quiz-scroll-to', [topPosition]);
          } else {
            $formatter.removeClass('show-quiz');
            $formatter.trigger('mantle-form:scroll-to-top');
            window.setTimeout(function () {
              $formatter.trigger('mantle-form:reset-ios-scroll');
            }, 100);
          }
        });

        var render_form = function (disable_form_active) {
          var $formStyleOneForm;

          if (!!disable_form_active) {
            $formatter.attr('data-disable-default-form-set-active', 1);
          }
          var $form = $('.js-form-formatter', $formatter);

          if ($form.length == 0) {
            $formContainer.html(quiz_form.html);
            Drupal.attachBehaviors($formContainer);
          }
          $formStyleOneForm = $formatter.find('.form-style--one_form');
          if (!$formatter.hasClass('entire-quiz-one-page') && $formStyleOneForm.length > 0) {
            $formatter.addClass('entire-quiz-one-page');
            $('html').addClass('one-form-page');
          }
          if (!!disable_form_active) {
            $formatter.attr('data-disable-default-form-set-active', 0);
          }
          $formatter.trigger('mantle-form:show-indicator-menu-bystep');
        };
        var show_form = function () {
          $formatter.addClass('show-quiz');
          $formatter.removeClass('show-results');
        };
        var calcTopPosition = function ($itemQuiz) {
          var $body = $('body');
          var openedStickyHead = $body.hasClass('sticky-header-opened');
          var $siteHeaderSticky = $('.js-site-header-sticky', $body).first();
          var extraHeight = 0;
          var topPosition = 0;

          if (openedStickyHead && $siteHeaderSticky.length > 0) {
            extraHeight = $siteHeaderSticky.height();
          }
          topPosition = $itemQuiz.position().top - extraHeight;

          return topPosition;
        };

        // Pop helper text on initial load.
        // TODO: hide this with cookie?
        $formatter.on('helper-text-initialized', '.js-mantle-form-options-field', function (e) {
          var $field = $(this);
          var field_name = $field.data('field-name');
          var helper_key = field_name + '_helper_seen';

          if ($formatter.data(helper_key)) {
            // already seen. don't show again.
            return;
          }
          var $link = $('.js-helper-text-link', $field);

          if ($link.length) {
            $link.click();
          }
          $formatter.data(helper_key, 1);
        });

        /*
         * Additional form reaction. TODO: move this into mantle_form. Put here
         * to expedite pushing since this is brand code.
         */
        $formatter.on('form-render-reactions', function (e) {
          $('.js-form-answer-reaction', $formatter).each(function (i, obj) {
            var $reaction = $(obj);

            if ($reaction.data('question-key')) {
              var question_key = $reaction.data('question-key');
              var reaction_type = 'text';

              if ($reaction.data('reaction-type')) {
                reaction_type = $reaction.data('reaction-type');
              }
              if (reaction_type == 'count-attr') {
                var $form = $('.js-form-formatter', $formatter).first();
                var manager = $form.data('form-manager');
                var $matched = manager.get_form_item_by_name(question_key);

                if ($('[data-slide-count]', $matched).length > 0) {
                  var slideCount = $('[data-slide-count]', $matched).data('slide-count');

                  $reaction.attr('data-answer-count', slideCount);
                } else {
                  var slideCount = $('mantle-form-options-field__item', $matched).length + 1;

                  $reaction.attr('data-answer-count', slideCount);
                }
              }
            }
          });
        });

        /*
         * Copy button from the form option to a sticky footer section.
         */
        $formatter.on('mantle-form:copy-button', function () {
          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');
          var $form_items = manager._form_items();
          var $active_field = $form_items.filter('.active');
          var $active_button = $('.mantle-form-options-field__footer-cta', $active_field);
          var $clone_button = $($active_button.html());

          $clone_button.data('original-button', $active_button);
          $stickyFooter.html($clone_button);
        });

        $formatter.on('mantle-form:optional-answer-enable-buttons', function () {
          var $formFormatter = $('.js-form-formatter', $formatter).first();
          var manager = $formFormatter.data('form-manager');
          var $formItems = manager._form_items();
          var formAnswers = manager.get_form_answers();
          var formInfo = manager.form_info;
          var invalid = MantleQuiz.validate_quiz_data(formInfo, formAnswers);
          var newInvalidFilterOptional = {};

          if (!$formFormatter.hasClass('form-style--one_form')) {
            return;
          }

          $formItems.each(function (i, obj) {
            var $formItem = $(obj);
            var isOptional =
              $('.js-mantle-form-options-field', $formItem).data('minCount') === 0 ? 1 : 0;
            var fieldName = $formItem.data('fieldName');

            // Filter invalid when is optional
            if (invalid[fieldName] === false && !isOptional) {
              newInvalidFilterOptional[fieldName] === false;
            }
          });
          // Enable skip button when the quiz option is optional.
          if ($.isEmptyObject(newInvalidFilterOptional)) {
            $formFormatter
              .find('.js-mantle-cta-button[data-trigger-type="submit"]')
              .removeClass('button--disabled');
          }
        });

        /*
         * After form js renders the button, recopy the button into the sticky
         * footer container.
         */
        $formatter.on('form-render-buttons', function (e) {
          $formatter.trigger('mantle-form:optional-answer-enable-buttons');
          $formatter.trigger('mantle-form:copy-button');
        });
        $formatter.on('form-auto-event-action', function () {
          var $formFormatter = $('.js-form-formatter', $formatter).first();
          var manager = $formFormatter.data('form-manager');
          var $formItems = manager._form_items();
          var $activeField = $formItems.filter('.active');
          var $itemsByOption = $();
          var hasItems = false;
          var $fieldCarousel = $('.js-range-slider-carousel__carousel', $activeField).first();
          var $fieldOption = $('.js-mantle-form-options-field', $activeField).first();
          var fieldName = $activeField.data('field-name');
          var isEditorial = $activeField.data('is-editorial') ? 1 : 0;

          if (!$formFormatter.hasClass('form-style--one_form')) {
            return;
          }
          if ($fieldCarousel.length > 0) {
            $itemsByOption = $fieldCarousel.find('.js-basic-carousel__slide');
            hasItems = true;
          } else if ($fieldOption.length > 0) {
            $itemsByOption = $fieldOption.find('.js-mantle-form__checkbox');
            hasItems = true;
          }
          if (!hasItems) {
            return;
          }
          if ($itemsByOption.length <= 2) {
            $activeField.css('min-height', 'auto');
          }
          if ($itemsByOption.length < 1) {
            if (!isEditorial) {
              $activeField.addClass('hidden');
            }
            $formFormatter.trigger('form-options-field-change', [fieldName]);
          } else if ($itemsByOption.length === 1) {
            $itemsByOption.first().click();
          }
        });

        /*
         * Proxy the click the form options field.
         */
        $stickyFooter.on('click', '.js-mantle-cta-button', function (e) {
          e.preventDefault();
          var $clone_button = $(this);
          var $active_button = $clone_button.data('original-button');
          var $cta_button = $('.js-mantle-cta-button', $active_button);

          $cta_button.click();
        });

        $formatter.on('mantle-form:reset-ios-scroll', function (e) {
          // The ios overflow touch seems to be heavily optimized. For dynamic
          // content, you need to reset the overflow setting to re-enable the
          // scrollbar.
          // instead of detecting ios directly. Just do a mobile check. This is
          // really only to fix IE11.
          if ($(window).width() > 768) {
            return;
          }
          var $scrollContainer = $('.js-quiz-landing-page-formatter__inner', $formatter);

          $scrollContainer.css('overflow-y', 'visible');
          window.setTimeout(function () {
            $scrollContainer.css('overflow-y', 'auto');
          }, 10);
        });
        $formatter.on('mantle-form:show-indicator-menu-bystep', function (e) {
          var $formFormatter = $('.js-form-formatter', $formatter).first();
          var manager = $formFormatter.data('form-manager');
          var $formItems = manager._form_items();
          var $formStepTrack = $('.js-form-step-track', $formFormatter).html();
          var startStep = 1;
          var $newStepByOrder;

          if ($formFormatter.hasClass('form-style--one_form')) {
            $formItems.each(function () {
              var $matched = $(this);
              var isEditorial = $matched.data('is-editorial') ? 1 : 0;
              var $currentStepTrack = $matched.find('.js-form-step-track');
              var currentStep = $matched.data('field-order') + startStep;
              if (
                $currentStepTrack.length <= 0 &&
                $formFormatter.hasClass('show-indicator-menu-bystep') &&
                !isEditorial
              ) {
                $newStepByOrder = $('<div />').addClass('form-step-track js-form-step-track');
                $newStepByOrder.html($formStepTrack);
                $matched.prepend($newStepByOrder);
                $newStepByOrder.find('.js-current-step').html(currentStep);
              }
            });
          }
        });

        $formatter.on('form-set-active-done', function (e, fieldName, form_answers) {
          var $formFormatter = $('.js-form-formatter', $formatter).first();
          var manager = $formFormatter.data('form-manager');
          var $matched = manager.get_form_item_by_name(fieldName);
          var $formItems = manager._form_items();
          var startStep = 1;
          var currentStep = $matched.data('field-order') + startStep;
          var topPosition = 0;

          if (!$formFormatter.hasClass('form-style--one_form')) {
            $formatter.trigger('mantle-form:scroll-to-top');
          }

          if ($formFormatter.hasClass('form-style--one_form')) {
            $formItems.removeClass('previous-displayed');
            $matched
              .nextAll('.js-form-formatter__item')
              .addClass('previous-displayed')
              .removeClass('hidden');

            if (currentStep > 1) {
              topPosition = calcTopPosition($matched);
              $formFormatter.trigger('quiz-scroll-to', [topPosition]);
            }
          }

          $formatter.trigger('mantle-form:copy-button');
          window.setTimeout(function () {
            $formatter.trigger('mantle-form:reset-ios-scroll');
          }, 100);

          if ($formatter.data('refreshing-from-url') == 1) {
            return;
          }

          var _query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);
          var query_string = '';

          if (fieldName != 'intro') {
            query_string = '_step=' + fieldName;
          }
          if (_query_string) {
            query_string = query_string + '&' + _query_string;
          }
          $formatter.trigger('form-set-pushstate', [query_string]);
        });

        $formatter.on('form-set-pushstate', function (e, query_string) {
          var stateObj = {};
          var new_url = window.location.pathname;

          if (!_.isEmpty(query_string)) {
            new_url = new_url + '?' + query_string;
          }

          history.pushState(stateObj, '', new_url);
        });

        $formatter.on('refresh-from-url-state', function (e, init_form) {
          $formatter.data('refreshing-from-url', 1);
          var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
          var current_step = JSBoot.URL.getParam('_step');

          // disable forms default
          show_form();
          render_form(true);
          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');

          manager.save_answers_to_form_state(query_answers, false);
          manager.apply_answers_from_form_state(true);
          $form.trigger('form-set-active', [current_step]);
          $formatter.data('refreshing-from-url', 0);
        });

        window.onpopstate = function (event) {
          if (JSBoot.URL.getParam('_step')) {
            $formatter.trigger('refresh-from-url-state', [false]);

            return;
          }
        };

        /*
         * This is the real init func
         */
        var _init = function () {
          var show_results = false;

          if (JSBoot.URL.getParam('show_results')) {
            show_results = true;
          }

          // var form_data = MantleForm.get_form_data_from_form_state_manager(form_name);
          var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
          var query_answers_valid = MantleForm.validate_form_answers_data(query_answers, quiz_info);

          if (query_answers_valid && show_results) {
            // don't trigger a push state
            $formatter.data('refreshing-from-url', 1);
            show_form();
            render_form(true);
            $formatter.trigger('mantle-form:request-form-results', [query_answers, true]);
            $formatter.data('refreshing-from-url', 0);

            return;
          }

          if (JSBoot.URL.getParam('_step')) {
            $formatter.trigger('refresh-from-url-state', [true]);

            return;
          }

          // The stuff below requires we have the user quiz state
          MantleQuiz.get_quiz_data(form_name).then(function (quiz_data) {
            // not answered. show quiz
            if (!quiz_data || !quiz_data.answered) {
              show_form();
              render_form();

              return;
            }

            var form_answers = quiz_data.answers;
            var form_answers_valid = MantleForm.validate_form_answers_data(form_answers, quiz_info);

            show_form();
            render_form();

            /*
             * Brand decided to not show results if you have them
            if (form_answers_valid) {
              $formatter.trigger('mantle-form:request-form-results', [form_answers, true]);
            }
            */
            return;
          });
        };

        // Run after all behaviors have attached.
        $(function () {
          _init();
        });
      });
    }
  };

  Drupal.behaviors.BBQuizHelperLink = {
    attach: function (context) {
      var $links = $('.js-helper-text-link', context);

      $links.each(function (i, obj) {
        var $link = $(obj);

        $link.on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          var $parent = $link.closest('.js-mantle-form-options-field');
          var $content = $('.mantle-form-options-field__helper-text', $parent);

          if ($content.length == 0) {
            return;
          }

          var options = {
            href: $content,
            className: 'colorbox--quiz colorbox--helper-text',
            escKey: false,
            inline: true, // retain state/events
            width: '535px'
          };

          options['onComplete'] = function () {
            $('.js-mantle-cta-button', $content).on('click.ugc-overlay', function (e) {
              $.colorbox.close();
            });
            $.colorbox.resize();
          };

          options['onCleanup'] = function () {
            $content.off('.ugc-overlay');
          };
          generic.overlay.launch(options);
        });
      });
    }
  };

  Drupal.behaviors.updateIosScrollbar = {
    attach: function (context) {
      // this is to handle ajax. On first load, fields should request an ios
      // scroll reset.
      var $option_fields = $('.js-mantle-form-options-field', context);

      if ($option_fields.length > 0) {
        window.setTimeout(function () {
          $option_fields.first().trigger('mantle-form:reset-ios-scroll');
        }, 100);
      }
    }
  };
})(jQuery);
